export default {
  mpmRow1: 'Digital MPM使制造商能够有效应对大规模定制的挑战。 通过使研发和工艺能够同时开发产品和进行工艺设计，Digital MPM可以使工艺设计与不断变化的产品规格快速保持一致，从而轻松处理来自多个客户的小订单。',
  mpmRow2: '轻松管理频繁且快速的生产线变更来执行订单',
  mpmRow3: '实时的产品数据、来自真实生产线的准确参数和丰富的数字化工艺库的组合，意味着可以为每个订单快速生成工艺参数和程序',
  mpmRow4: '选择并重用工艺库的经验以持续提高生产力。 集成机器学习，意味着工艺经验库不断被优化越来越智能，并且可以更高效的改变。'
}
